<script setup lang="ts">
import SensitiveInfoDrawer from '~/components/shared/SensitiveInfoDrawer.vue';
import LoadingDialog from './components/LoadingDialog.vue';
</script>

<template>
  <div class="h-full">
    <NuxtLoadingIndicator color="#313A68" :height="5" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <SensitiveInfoDrawer />
    <Toast position="bottom-center" />
    <LoadingDialog />
  </div>
</template>
